import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform, BlurView } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Ionicons } from '@expo/vector-icons';
import { colors } from '../constants/colors';
import { NavigationProp } from '@react-navigation/native';

interface CampusMapScreenProps {
  navigation: NavigationProp<any>;
}

const CampusMapScreen: React.FC<CampusMapScreenProps> = ({ navigation }) => {
  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.content}>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.headerContent}>
            <View style={styles.greetingContainer}>
              <Text style={styles.greeting}>Find your way around campus</Text>
              <View style={styles.titleContainer}>
                <Text style={styles.headerTitle}>Campus</Text>
                <Text style={[styles.headerTitle, { color: colors.primary }]}> Map</Text>
              </View>
            </View>
            <View style={styles.headerRight}>
       
            </View>
          </View>
          <View style={styles.headerDecoration} />
        </View>

        <View style={styles.contentContainer}>
          {/* Location Selectors */}
          <View style={styles.locationContainer}>
            <View style={styles.locationSelectors}>
              <TouchableOpacity style={styles.locationButton}>
                <Ionicons name="location" size={24} color={colors.primary} />
                <View style={styles.locationTextContainer}>
                  <Text style={styles.locationLabel}>Start</Text>
                  <Text style={styles.locationValue}>Select starting point</Text>
                </View>
                <Ionicons name="chevron-forward" size={24} color={colors.textSecondary} />
              </TouchableOpacity>

              <TouchableOpacity style={[styles.locationButton, { opacity: 0.5 }]} disabled>
                <Ionicons name="flag" size={24} color={colors.disabled} />
                <View style={styles.locationTextContainer}>
                  <Text style={styles.locationLabel}>Destination</Text>
                  <Text style={[styles.locationValue, styles.disabledText]}>
                    Select destination
                  </Text>
                </View>
                <Ionicons name="chevron-forward" size={24} color={colors.disabled} />
              </TouchableOpacity>
            </View>
          </View>

          {/* Overlay with blur and Coming Soon */}
          <View style={styles.overlay}>
            <View style={styles.blur} />
            <View style={styles.comingSoonContainer}>
              <Text style={styles.comingSoonText}>Coming Soon 🗺️</Text>
            </View>
          </View>
        </View>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  content: {
    flex: 1,
    paddingHorizontal: 20,
  },
  header: {
    paddingTop: 20,
    paddingBottom: 15,
    backgroundColor: colors.surface,
    borderBottomLeftRadius: 24,
    borderBottomRightRadius: 24,
    marginHorizontal: -20,
    paddingHorizontal: 20,
    position: 'relative',
    ...Platform.select({
      ios: {
        shadowColor: colors.text,
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.1,
        shadowRadius: 8,
      },
      android: {
        elevation: 4,
      },
    }),
  },
  headerContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  greetingContainer: {
    flex: 1,
  },
  greeting: {
    fontSize: 16,
    color: colors.textLight,
    marginBottom: 4,
  },
  titleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerTitle: {
    fontSize: 28,
    fontWeight: 'bold',
    color: colors.text,
  },
  headerRight: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  searchButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: colors.surface,
    justifyContent: 'center',
    alignItems: 'center',
    ...Platform.select({
      ios: {
        shadowColor: colors.text,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
      },
      android: {
        elevation: 2,
      },
    }),
  },
  headerDecoration: {
    position: 'absolute',
    bottom: 0,
    left: 20,
    right: 20,
    height: 4,
    backgroundColor: colors.primary,
    opacity: 0.1,
    borderRadius: 2,
  },
  contentContainer: {
    flex: 1,
    position: 'relative',
  },
  locationContainer: {
    flex: 1,
    padding: 16,
  },
  locationSelectors: {
    marginBottom: 20,
  },
  locationButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.surface,
    padding: 16,
    borderRadius: 12,
    marginBottom: 12,
    ...Platform.select({
      ios: {
        shadowColor: colors.text,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
      },
      android: {
        elevation: 2,
      },
    }),
  },
  locationTextContainer: {
    flex: 1,
    marginLeft: 12,
  },
  locationLabel: {
    fontSize: 12,
    color: colors.textLight,
    marginBottom: 4,
  },
  locationValue: {
    fontSize: 16,
    color: colors.text,
    fontWeight: '500',
  },
  disabledText: {
    color: colors.disabled,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
    alignItems: 'center',
  },
  blur: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    backdropFilter: 'blur(5px)',
  },
  comingSoonContainer: {
    padding: 20,
    borderRadius: 12,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    ...Platform.select({
      ios: {
        shadowColor: colors.text,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
      },
      android: {
        elevation: 4,
      },
    }),
  },
  comingSoonText: {
    fontSize: 24,
    fontWeight: 'bold',
    color: colors.text,
  },
});

export default CampusMapScreen;
